import content from "./content";
import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getSeo, serializeJsonLd } from './seo';
import { Helmet } from 'react-helmet';
import { FiArrowRight, FiUsers, FiMapPin, FiTag, FiSun, FiMenu, FiX, FiPlay, FiMail, FiPhone, FiCalendar, FiInfo, FiHome, FiWifi, FiWind, FiMonitor, FiGrid, FiChevronLeft, FiChevronRight, FiCheck } from 'react-icons/fi';
const icons = {
  arrow: FiArrowRight,
  users: FiUsers,
  pin: FiMapPin,
  tag: FiTag,
  sun: FiSun,
  menu: FiMenu,
  close: FiX,
  play: FiPlay,
  mail: FiMail,
  phone: FiPhone,
  calendar: FiCalendar,
  info: FiInfo,
  home: FiHome,
  wifi: FiWifi,
  air: FiWind,
  tv: FiMonitor,
  grid: FiGrid,
  left: FiChevronLeft,
  right: FiChevronRight,
  check: FiCheck
};
export function Icon({
  name,
  ...props
}) {
  if (name === 'waves') return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="icon" aria-hidden="true" {...props}><path d="M2 6q2-3 5 0t5 0 5 0 5 0M2 12q2-3 5 0t5 0 5 0 5 0M2 18q2-3 5 0t5 0 5 0 5 0" /></svg>;
  const Component = icons[name] || FiCheck;
  return <Component className="icon" aria-hidden="true" {...props} />;
}
export function Brand() {
  return <Link className="brand" to="/" aria-label={content.navigation.brandLabel}><svg viewBox="0 0 62 58" aria-hidden="true"><g stroke="#D69A35" strokeWidth="1.8" strokeLinecap="round"><path d="M31 2v6M17 6l3 5M7 16l5 3M3 29h6M45 6l-3 5M55 16l-5 3M59 29h-6" /><path d="M14 34a17 17 0 0 1 34 0" fill="#D69A35" /></g><g fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 39q9-5 18 0t18 0 20 0M3 47q9-5 18 0t18 0 20 0" /></g></svg><span>{content.site.name}</span></Link>;
}
export function PageTitle() {
  const { pathname } = useLocation();
  const seo = getSeo(pathname);
  return <Helmet>
    <title>{seo.title}</title>
    <meta name="description" content={seo.description} />
    <link rel="canonical" href={seo.url} />
    <meta property="og:url" content={seo.url} />
    <meta property="og:type" content="website" />
    <meta property="og:title" content={seo.title} />
    <meta property="og:description" content={seo.description} />
    <meta property="og:image" content={seo.image} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={seo.title} />
    <meta name="twitter:description" content={seo.description} />
    <meta name="twitter:image" content={seo.image} />
    <script type="application/ld+json">{serializeJsonLd(seo.structuredData)}</script>
  </Helmet>;
}
export function ButtonLink({
  to,
  children,
  light = false,
  outline = false,
  className = '',
  ...props
}) {
  return <Link to={to} className={['button', light && 'button-light', outline && 'button-outline', className].filter(Boolean).join(' ')} {...props}>{children}<Icon name="arrow" /></Link>;
}
export function Callout({
  title = content.common.callout.title,
  text = content.common.callout.text,
  to = '/contact',
  label = content.common.contact
}) {
  return <section className="callout"><div><h2>{title}</h2><p>{text}</p></div><ButtonLink to={to}>{label}</ButtonLink></section>;
}
export function SeaPicture({
  className = '',
  alt = content.media.sea.alt,
  eager = false
}) {
  return <picture className={'sea-picture ' + className}><source srcSet={content.media.sea.avif} type="image/avif" /><img src={content.media.sea.src} alt={alt} loading={eager ? 'eager' : 'lazy'} fetchpriority={eager ? 'high' : 'auto'} decoding="async" /></picture>;
}

export function TextLines({ lines }) {
  return lines.map((line, index) => <Fragment key={index}>{index > 0 && <br />}{line}</Fragment>);
}

export function GitePicture({ src, alt, ...props }) {
  return <picture className="gite-picture"><source srcSet={src.replace(/\.jpe?g$/i, '.avif')} type="image/avif" /><img src={src} alt={alt} {...props} /></picture>;
}
